import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';

const ChatViewContainer = styled(Stack)(({ theme }) => {
  const { palette } = theme.vars ? theme.vars : theme;
  return {
    backgroundColor: palette.background.default,
    flexGrow: 1,
    border: `2px solid ${palette.divider}`,
    borderBottom: 'none',
    height: 0,
  };
});

export interface ChatViewProps {
  header?: ReactNode;
  messages: ReactNode;
  input?: ReactNode;
  sx?: SxProps<Theme>;
}

export const ChatView = ({ header, messages, input, sx }: ChatViewProps) => (
  <Stack sx={{ height: '100%' }}>
    {header}
    <ChatViewContainer sx={sx}>
      {messages}
      {input}
    </ChatViewContainer>
  </Stack>
);
